/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CapabilityID,
  CapabilityID$inboundSchema,
  CapabilityID$outboundSchema,
} from "./capabilityid.js";

export type WebhookDataCapabilityRequested = {
  accountID: string;
  foreignID?: string | undefined;
  /**
   * Moov account capabilities.
   *
   * @remarks
   *
   * The `production-app`, `platform.production-app`, and / or `platform.wallet-transfers` capabilities might appear in your list. These are read-only capabilities that Moov requests and uses for account verification purposes. These capabilities remains active with your account and require no additional action.
   */
  capabilityID: CapabilityID;
};

/** @internal */
export const WebhookDataCapabilityRequested$inboundSchema: z.ZodType<
  WebhookDataCapabilityRequested,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
  foreignID: z.string().optional(),
  capabilityID: CapabilityID$inboundSchema,
});
/** @internal */
export type WebhookDataCapabilityRequested$Outbound = {
  accountID: string;
  foreignID?: string | undefined;
  capabilityID: string;
};

/** @internal */
export const WebhookDataCapabilityRequested$outboundSchema: z.ZodType<
  WebhookDataCapabilityRequested$Outbound,
  z.ZodTypeDef,
  WebhookDataCapabilityRequested
> = z.object({
  accountID: z.string(),
  foreignID: z.string().optional(),
  capabilityID: CapabilityID$outboundSchema,
});

export function webhookDataCapabilityRequestedToJSON(
  webhookDataCapabilityRequested: WebhookDataCapabilityRequested,
): string {
  return JSON.stringify(
    WebhookDataCapabilityRequested$outboundSchema.parse(
      webhookDataCapabilityRequested,
    ),
  );
}
export function webhookDataCapabilityRequestedFromJSON(
  jsonString: string,
): SafeParseResult<WebhookDataCapabilityRequested, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WebhookDataCapabilityRequested$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WebhookDataCapabilityRequested' from JSON`,
  );
}
